// Google Analytics 4 — САМО за уеб версията (app.livupp.com), за да виждаме
// пътя на посетителите от реклама: зареждане → търсене → регистрация.
// На телефон (iOS/Android) не прави нищо.
import { Platform } from 'react-native';
import { API_URL } from './api';

const GA_ID = 'G-4KC2SNPG1X';
// Meta Pixel (Events Manager → Datasets → Livupp). Публичен идентификатор, не е тайна.
const META_PIXEL_ID = '1130891192701717';
// Кои наши събития кои стандартни събития на Meta задействат (за оптимизация на реклами).
const META_EVENTS: Record<string, string> = {
  reputation_search: 'Search',
  register_start: 'InitiateCheckout',
  otp_sent: 'Lead',
  registered: 'CompleteRegistration',
};
let ready = false;

export function initAnalytics(): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined' || ready) return;
  ready = true;
  const w = window as any;
  w.dataLayer = w.dataLayer || [];
  if (typeof w.gtag !== 'function') {
    // gtag.js обработва само записи от тип `arguments`
    w.gtag = function gtag() {
      // eslint-disable-next-line prefer-rest-params
      w.dataLayer.push(arguments);
    };
  }
  w.gtag('js', new Date());
  w.gtag('config', GA_ID, { send_page_view: true });
  const s = document.createElement('script');
  s.async = true;
  s.src = `https://www.googletagmanager.com/gtag/js?id=${GA_ID}`;
  document.head.appendChild(s);
  initMetaPixel();

  // Необработени грешки → app_error в GA + запис на нашия сървър (с текст)
  window.addEventListener('error', (e) => {
    const message = String(e?.message ?? 'error').slice(0, 120);
    if (isIgnoredError(message)) return; // шум от Facebook/Instagram in-app браузъра
    track('app_error', { message });
    reportClientError(message, 'error');
  });
  window.addEventListener('unhandledrejection', (e: any) => {
    const r = e?.reason;
    const message = String(r?.message ?? r ?? 'rejection').slice(0, 120);
    if (isIgnoredError(message)) return;
    track('app_error', { message, kind: 'promise' });
    reportClientError(message, 'promise');
  });
}

// Изпраща грешката на сървъра (без вход, без лични данни). Мрежови грешки от
// самото изпращане се игнорират — иначе ще зациклим.
// Известен шум от чужди скриптове (вграденият браузър на Facebook за Android
// инжектира своя „мост“, който гърми при излизане) — не е наша грешка.
const IGNORED = [/Java object is gone/i, /^Script error\.?$/i];
export const isIgnoredError = (message: string) => IGNORED.some((re) => re.test(message));

let reported = 0;
export function reportClientError(message: string, kind: string): void {
  if (typeof fetch !== 'function' || reported >= 5) return;
  if (isIgnoredError(message)) return;
  reported += 1;
  // Адрес на екрана без fbclid/utm опашката — пътят и „#check“-частта са важните
  const url =
    Platform.OS === 'web' && typeof window !== 'undefined'
      ? `${window.location.origin}${window.location.pathname}${window.location.hash}`.slice(0, 300)
      : Platform.OS;
  fetch(`${API_URL}/client-errors`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ message: message.slice(0, 500), kind, url }),
  }).catch(() => {});
}

// Meta Pixel — официалният фрагмент, без jQuery/inline скрипт. PageView при
// зареждане; следващите събития минават през track(). Без лични данни.
function initMetaPixel(): void {
  const w = window as any;
  if (typeof w.fbq === 'function') return;
  const fbq = function fbq(this: unknown) {
    const q = fbq as unknown as { callMethod?: (...a: unknown[]) => void; queue: unknown[] };
    // eslint-disable-next-line prefer-rest-params
    if (q.callMethod) q.callMethod.apply(fbq, Array.prototype.slice.call(arguments));
    else q.queue.push(arguments); // eslint-disable-line prefer-rest-params
  } as unknown as Record<string, unknown> & ((...a: unknown[]) => void);
  fbq.push = fbq;
  fbq.loaded = true;
  fbq.version = '2.0';
  fbq.queue = [] as unknown[];
  w.fbq = fbq;
  if (!w._fbq) w._fbq = fbq;
  const s = document.createElement('script');
  s.async = true;
  s.src = 'https://connect.facebook.net/en_US/fbevents.js';
  document.head.appendChild(s);
  w.fbq('init', META_PIXEL_ID);
  w.fbq('track', 'PageView');
}

// Събитие по стъпка от фунията (напр. 'reputation_search', 'register_start',
// 'otp_sent', 'registered'). Параметрите са без лични данни.
export function track(event: string, params: Record<string, string | number | boolean> = {}): void {
  if (Platform.OS !== 'web' || typeof window === 'undefined') return;
  const w = window as any;
  if (typeof w.gtag === 'function') w.gtag('event', event, params);
  const meta = META_EVENTS[event];
  if (meta && typeof w.fbq === 'function') w.fbq('track', meta, params);
}
